import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { GetState } from "../config/store";
import { 
    cleanGetUsers as cleanGetUsersReducer,
    addUserRequest,
    addUserSuccess,
    addUserFailure,
    cleanAddUser as cleanAddUserReducer,
    editUserRequest,
    editUserSuccess,
    editUserFailure,
    cleanEditUser as cleanEditUserReducer,
    disabledUserRequest,
    disabledUserSuccess,
    disabledUserFailure,
    cleanDisabledUser as cleanDisabledUserReducer,
    deleteUserRequest,
    deleteUserSuccess,
    deleteUserFailure,
    cleanDeleteUser as cleanDeleteUserReducer,
    getReportsRequest,
    getReportsSuccess,
    getReportsFailure
} from "../reducers/users";
import { UserSidebarProps } from "../interfaces/users";
import { UsersValidTypes } from "../interfaces/types";
import { axiosClient } from "../config/axios";
import { cleanGetPickupPoints as cleanGetPickupPointsReducer, addPickupPointsFailure, addPickupPointsRequest, addPickupPointsSuccess, cleanDeletePickupPoints, deletePickupPointsFailure, deletePickupPointsRequest, deletePickupPointsSuccess, getPickupPointsFailure, getPickupPointsRequest, getPickupPointsSuccess, editPickupPointsRequest, editPickupPointsSuccess, editPickupPointsFailure, cleanAddPickupPoints, cleanEditPickupPoints, getRegionsRequest, getRegionsSuccess, getRegionsFailure, cleanGetRegions as cleanGetRegionsReducer, getCitiesRequest, getCitiesSuccess, getCitiesFailure, cleanGetCities as cleanGetCitiesReducer, getCommunesRequest, getCommunesSuccess, getCommunesFailure, cleanGetCommunes as cleanGetCommunesReducer } from "../reducers/pickupPoints";

export const getPickupPoints = (data: any) => (dispatch: Dispatch) => _getPickupPoints(data, dispatch);
const _getPickupPoints = async (data: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: getPickupPointsRequest });

        const response = await axiosClient.get(`${api.settings}/inspection-points`);
        console.log(response);
        
        dispatch({ 
            type: getPickupPointsSuccess, 
            payload: {
                pickupPoints: response?.data?.data?.inspection_points,
                total: response?.data?.data?.total
            }
        });

    } catch (error: any) {
        console.log(error);
        dispatch({ type: getPickupPointsFailure, payload: error });
    }
};

export const cleanGetPickupPoints = () => (dispatch: Dispatch) => _cleanGetPickupPoints(dispatch);
const _cleanGetPickupPoints = async (dispatch: Dispatch) => dispatch({type: cleanGetPickupPointsReducer});

export const addPickupPoint = (point: any) => (dispatch: Dispatch) => _addPickupPoint(point, dispatch);
const _addPickupPoint = async (point: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: addPickupPointsRequest });

        const body = JSON.stringify(point);

        const response = await axiosClient.post(`${api.settings}/inspection-points`, body);

        dispatch({ 
            type: addPickupPointsSuccess, 
            payload: response?.data?.data
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: addPickupPointsFailure, payload: errorResponse });
    }
};

export const cleanAddPickupPoint = () => (dispatch: Dispatch) => _cleanAddPickupPoint(dispatch);
const _cleanAddPickupPoint = async (dispatch: Dispatch) => dispatch({type: cleanAddPickupPoints});

export const editPickupPoint = (id: string, point: any) => (dispatch: Dispatch) => _editPickupPoint(id, point, dispatch);
const _editPickupPoint = async (id: string, point: any, dispatch: Dispatch) => {
    try {
        dispatch({ type: editPickupPointsRequest });

        const body = JSON.stringify(point);

        const response = await axiosClient.put(`${api.settings}/inspection-points/${id}`, body);

        dispatch({ type: editPickupPointsSuccess, payload: response?.data?.data });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: editPickupPointsFailure, payload: errorResponse });
    }
};

export const cleanEditPickupPoint = () => (dispatch: Dispatch) => _cleanEditPickupPoint(dispatch);
const _cleanEditPickupPoint = async (dispatch: Dispatch) => dispatch({type: cleanEditPickupPoints});

export const disabledUser = (id: string, disabled: boolean) => (dispatch: Dispatch) => _disabledUser(id, disabled, dispatch);
const _disabledUser = async (id: string, disabled: boolean, dispatch: Dispatch) => {
    try {
        dispatch({ type: disabledUserRequest });

        const body = JSON.stringify({ disabled: disabled });

        const response = await axiosClient.patch(`${api.users}/${id}`, body);

        dispatch({ 
            type: disabledUserSuccess, 
            payload: response?.data?.data
        });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: disabledUserFailure, payload: errorResponse });
    }
};

export const cleanDisabledUser = () => (dispatch: Dispatch) => _cleanDisabledUser(dispatch);
const _cleanDisabledUser = async (dispatch: Dispatch) => dispatch({type: cleanDisabledUserReducer});

export const deletePickupPoint = (id: string) => (dispatch: Dispatch) => _deletePickupPoint(id, dispatch);
const _deletePickupPoint = async (id: string, dispatch: Dispatch) => {
    try {
        dispatch({ type: deletePickupPointsRequest });

        const response = await axiosClient.delete(`${api.settings}/inspection-points/${id}`);

        dispatch({ type: deletePickupPointsSuccess, payload: response?.data?.data});

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.log(errorResponse);
        dispatch({ type: deletePickupPointsFailure, payload: errorResponse });
    }
};

export const cleanDeletePickupPoint = () => (dispatch: Dispatch) => _cleanDeletePickupPoint(dispatch);
const _cleanDeletePickupPoint = async (dispatch: Dispatch) => dispatch({type: cleanDeletePickupPoints});

export const getRegions = () => (dispatch: Dispatch) => _getRegions(dispatch);
const _getRegions = async (dispatch: Dispatch) => {
    try {
        dispatch({ type: getRegionsRequest });

        const response = await axiosClient.get(`${api.users}/regions`);
    
        dispatch({ 
            type: getRegionsSuccess, 
            payload: response?.data?.data
        });

    } catch (error: any) {
        console.log('Error al obtener regiones:', error);
        dispatch({ type: getRegionsFailure, payload: error });
    }
};

export const cleanGetRegions = () => (dispatch: Dispatch) => _cleanGetRegions(dispatch);
const _cleanGetRegions = async (dispatch: Dispatch) => dispatch({type: cleanGetRegionsReducer});

export const getCities = (regionId: number) => (dispatch: Dispatch) => _getCities(regionId, dispatch);
const _getCities = async (regionId: number, dispatch: Dispatch) => {
    try {
        dispatch({ type: getCitiesRequest });

        const response = await axiosClient.get(`${api.users}/cities/region/${regionId}`);

        dispatch({ 
            type: getCitiesSuccess, 
            payload: response?.data?.data?.city || []
        });

    } catch (error: any) {
        console.log('Error al obtener ciudades:', error);
        dispatch({ type: getCitiesFailure, payload: error });
    }
};

export const cleanGetCities = () => (dispatch: Dispatch) => _cleanGetCities(dispatch);
const _cleanGetCities = async (dispatch: Dispatch) => dispatch({type: cleanGetCitiesReducer});

export const getCommunes = (cityId: number) => (dispatch: Dispatch) => _getCommunes(cityId, dispatch);
const _getCommunes = async (cityId: number, dispatch: Dispatch) => {
    try {
        dispatch({ type: getCommunesRequest });

        const response = await axiosClient.get(`${api.users}/communes/city/${cityId}`);

        dispatch({ 
            type: getCommunesSuccess, 
            payload: response?.data?.data?.company || []
        });

    } catch (error: any) {
        console.log('Error al obtener comunas:', error);
        dispatch({ type: getCommunesFailure, payload: error });
    }
};

export const cleanGetCommunes = () => (dispatch: Dispatch) => _cleanGetCommunes(dispatch);
const _cleanGetCommunes = async (dispatch: Dispatch) => dispatch({type: cleanGetCommunesReducer});
